import {
    RuntimeEventData,
    ProtocolType,
    EventsMap,
} from '@/app/modules/Metrics/types';

/**
 * @see ProtocolType
 */
export enum ProtocolTypes {
    YMETRIKA = 'YMETRIKA',
    CSC = 'CSC',
    ONEDMP = 'ONEDMP',
}
/**
 * Интерфейс вьюшного сервиса
 */
export interface iMetricsService {
    registerEvents(events: RealEventsMap): void;
    transmit(event: string, runtimeEventData?: RuntimeEventData): void;
}

/**
 * Тип EventsMap, с уточненными типами обработчиков
 */
export type RealEventsMap = EventsMap<Partial<ProtocolType>>; // @TODO: ProtocolTypes
